require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./about-us-credit-union-vs-bank.json") })
        }
      }, "path---about-us-credit-union-vs-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---about-us-credit-union-vs-bank!./.cache/json/about-us-credit-union-vs-bank.json
// module id = 1538
// module chunks = 231608221292675